import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import AllTask from "./AllTask";
import { FilePlus, PenTool, PlusSquare } from "react-feather";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AddTask = ({project_id}) => {
  const adminID = localStorage.getItem("adminID");
  const [assignees, setAssignees] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [subTaskTitle, setSubTaskTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [refreshKey, setRefreshKey] = useState(0);
  

  console.log("project_id",project_id);


  useEffect(() => {
    if (adminID) {
      axios
        .get(`${baseurl}getAssigneesByOrgId/${adminID}`)
        .then((res) => {
          const formatted = res.data.assignees?.map((item) => ({
            label: item.full_name,
            value: item.id,
            profileImageUrl: item.profile_image
              ? `${imageUrl}assignee/${item.profile_image}`
              : null,
          }));
          setAssignees(formatted || []);
        })
        .catch((err) => console.error("Failed to fetch assignees", err));
    }
  }, [adminID]);

  const customSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "start" }}>
      {data.profileImageUrl ? (
        <img
          src={data.profileImageUrl}
          alt={data.label}
          className="mx-2"
          style={{ width: 30, height: 30, borderRadius: "50%", marginRight: 10, marginLeft: 20 }}
        />
      ) : (
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            backgroundColor: "#007bff",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 10,
          }}
        >
          {data.label.charAt(0).toUpperCase()}
        </div>
      )}
      {data.label}
    </div>
  );

  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "start" , cursor : "pointer" , }}>
        {data.profileImageUrl ? (
          <img
            src={data.profileImageUrl}
            alt={data.label}
            style={{ width: 30, height: 30,cursor : "pointer" , borderRadius: "50%", marginRight: 10, marginLeft: 10,marginBottom : 10, }}
          />
        ) : (
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              backgroundColor: "#007bff",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: 10, cursor : "pointer" ,
              marginLeft: 10, marginBottom : 10, 
            }} className="mb-2"
          >
            {data.label.charAt(0).toUpperCase()}
          </div>
        )}
        {data.label}
      </div>
    );
  };

  const handleAddTask = () => {
    if (!subTaskTitle.trim()) return;
  
    const formData = new FormData();
    formData.append("title", subTaskTitle);
    formData.append("description", description);
    formData.append("project_id", project_id);
    formData.append("assignees", JSON.stringify(selectedAssignees.map(a => a.value)));
    if (selectedFile) formData.append("file", selectedFile);
  
    console.log("Form Data:");
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }
  
    axios
      .post(`${baseurl}createSubtask`, formData)
      .then((res) => {
        setSubTaskTitle("");
        setDescription("");
        setSelectedAssignees([]);
        setSelectedFile(null);
  
        const modal = document.getElementById("exampleModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();
  
        toast.success("Task added successfully!");

        setRefreshKey((oldKey) => oldKey + 1);


      })
      .catch((err) => {
        console.error("Failed to add task", err);
        toast.error("Failed to add subtask. Please try again.");
      });
  };

  return (
    <div className="mb-1">
      <div className="d-flex  ">
        <h5 className="add-task11 text-start  " 
        data-bs-toggle="modal" data-bs-target="#exampleModal"
        >Add Sub Task <FilePlus size={15} /></h5>
        {/* <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        >
          Add Task
        </button> */}
      </div>




<div>
    {/* <AllTask project_id = {project_id}/> */}
    <AllTask project_id={project_id} refreshKey={refreshKey} />
</div>





      {/* Modal */}
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Task</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label w-100 text-start">Assign To</label>
                <Select
                  options={assignees}
                  value={selectedAssignees}
                  onChange={setSelectedAssignees}
                  getOptionLabel={(e) => e.label}
                  components={{ SingleValue: customSingleValue, Option: customOption }}
                  isMulti
                  className="w-100"
                />
              </div>

              <div className="mb-3">
                <label className="form-label text-start w-100">SubTask/Task  Title</label>
                <input
                  type="text"
                  className="form-control" placeholder="Enter Task Here"
                  value={subTaskTitle}
                  onChange={(e) => setSubTaskTitle(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label text-start w-100">Description</label>
                <textarea
                  className="form-control"
                  rows="3" placeholder="Enter Note (If any)"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label text-start w-100">Upload File</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={handleAddTask} type="button" className="custom-btn green">
                Add Task
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />


    </div>


  );
};

export default AddTask;
